import ar from 'vuetify/src/locale/ar.ts';

export default {
  $vuetify: {
    ...ar, //needed to handle $vuetify.noDataText value
    OPERATOR: 'موفر خدمة المحمول',
    OPERATORANDWALLET: 'موفر خدمة المحمول / المحفظة',
    MOBILENUMBER: 'رقم الهاتف المحمول',
    COUNTRYREQUIRED: 'البلد مطلوب',
    OPERATORREQUIRED: 'موفر خدمة المحمول مطلوب',
    MOBILENUMBERREQUIRED: 'رقم الهاتف مطلوب',
    PINCODE: 'رمز التحقق',
    PINCODEREQUIRED: 'رمز التحقق مطلوب',
    RESENDPIN: 'إعادة إرسال رمز التحقق',
    ALREADYSUBSCRIBEDERR: 'أنت مشترك بالفعل بخدمة ',
    TERMSOFUSE: 'شروط الاستخدام',
    COUNTRY: 'بلد',
    INVALIDPINCODE: 'رمز التحقق غير صحيح',
    REJECTEDSUBSCRIPTION: 'الاشتراك ملغى من قبل التاجر',
    ALREADYSUBSCRIBED: 'هذا المستخدم مشترك بالفعل في المنتج المحدد',
    GENERALERRORMESSAGE: 'لقد حدث خطأ، رجاء إعادة المحاولة لاحقا',
    PINCODESENTSUCCESS: `لقد تم إرسال رمز التحقق إلى هاتفك المحمول ، يرجى التحقق مرة أخرى!`,
    PAYBYMOBILE: 'الدفع عن طريق الهاتف',
    CODESENTTO: 'تم ارسال رمز التحقق الي ',
    EXPIREDPINCODE: 'انتهت صلاحية رمز التحقق',
    RESENDTRIALSEXCEEDED: 'لقد تجاوزت عدد إعادة إرسال رمز التحقق',
    INVALIDTRIALSEXCEEDED: 'لقد تجاوزت الحد الاقصى لمحاولات ادخال رمز التحقق',
    INVALIDMSISDN: 'يرجى إدخال رقم هاتف صحيح لمشغل الهاتف المحمول المحدد.',
    INVALIDNUMBER: 'يرجى إدخال {mobile_label} صحيح.',
    GENERALFAILUREMESSAGE: 'حدث خطا خلال عملية الدفع',
    RESPONSECODE_1: 'فشل في إرسال رمز التحقق ، يرجى المحاولة مرة أخرى',
    RESPONSECODE_2: 'تم إلغاء المعاملة',
    RESPONSECODE_4: 'ليس لديك رصيد كاف',
    RESPONSECODE_5: 'قيمة الشراء تتجاوز القيمة المسموح بها في عملية الشراء',
    RESPONSECODE_9: 'لقد حدث خطأ، رجاء إعادة المحاولة ',
    RESPONSECODE_11: 'رمز التحقق غير صحيح، رجاء إعادة المحاولة',
    RESPONSECODE_19: 'لقد انتهت مهلة طلبك, يرجي محاولة شراءالمنتج مرة اخرى',
    RESPONSECODE_22: `يرجى إدخال رقم هاتف صحيح لمشغل الهاتف المحمول المحدد.`,
    RESPONSECODE_14: `هذه الخدمة ليست متاحة للحساب الخاص بك، يرجى الاتصال بخدمة العملاء`,
    RESPONSECODE_16: 'انتهت صلاحية رمز التحقق، رجاء إعادة المحاولة ',
    RESPONSECODE_51: 'لقد حدث خطأ، رجاء إعادة المحاولة ',
    RESPONSECODE_101: 'تم الخصم من المحفظة ولكن لم نتمكن من الوصول  الى المورد',
    RESPONSECODE_102: 'لا يمكن إتمام المعاملة بسبب اكتشاف نشاط غير مألوف',
    RESPONSECODE_103: 'انتهت مدة جلستك',
    RESPONSECODE_104: `هذا الرقم محظور`,
    RESPONSECODE_105: `عفواً، لا يمكنك استخدام خدمة الدفع قبل استهلاك 200 ريال أو أكثر من رصيدك في خدمات موبايلي الأخرى.`,
    RESPONSECODE_202: `جارى تنفيذ المعاملة`,

    FirstName: 'الاسم الأول',
    LastName: 'اسم العائلة',
    Email: 'البريد الإلكتروني',
    AccountNumber: 'رقم الحساب',
    requiredInput: 'حقل مطلوب',
    invalidInputFormat: 'الصيغة غير صحيحة',
    UNAUTHORIZEDUSER: 'مستخدم غير مصرح به',
    EXPIREDSESSION_TITLE: 'انتهت مدة جلستك',
    EXPIREDSESSION_MSG: 'انتهت جلستك. يرجى العودة للمتجر والمحاولة مرة أخرى',
    
    VATINCLUDED: 'شامل ضريبة القيمة المضافة',
    VATEXCLUDED: 'غير شامل ضريبة القيمة المضافة',
    PVATINCLUDED: ' السعر يشمل {percent} % ضريبة القيمة المضافة',
    PVATEXCLUDED: ' السعر لا يشمل {percent} % ضريبة القيمة المضافة',

    FREETRIALCONSUMED: `سيتم اشتراكك في الخدمة بدون فترة تجريبية مجانية لأنك استهلكت الفترة التجريبية من قبل.`,
    PLAN: '',
    DAYSFREETRIAL: 'أيام تجربة مجانية!',
    FRAUDTOOLERRORMSG: 'لا يمكن إتمام المعاملة بسبب اكتشاف نشاط غيرمألوف',
    MOBILENUMBER_TOO_SHORT_VALIDITY: '{mobile_label} غير كامل',
    PINCODE_DIGITS_ONLY: 'يجب أن يتكون رمز التحقق من أرقام فقط',
    UNSUBSCRIBE_ERROR_MSG: `أنت غير مشترك في <span dir="ltr">{plan_name}</span>`,
    PINCODENOTSENT: 'لم يتم ارسال رمز التحقق',
    PINCODE_LIMITS: 'يجب أن يتراوح رمز التحقق ما بين 4 الي 6 أرقام.',

    OPERATOR_VALIDATION_ALERT: `موفر الخدمة الذي تم اختياره هو {operator} {country}.`,
    ENTER_MOBILE_MSG: 'الرجاء إدخال رقم هاتفك المتحرك التابع {operator}',
    TermsCheckbox_MSG:
      'أوافق على الشروط والأحكام وأوافق على الإذن لمشاركة بياناتي مع شركاء اتصالات والشركات التابعة لها',
    ENTER_PINCODEWITHLENGTH_MSG:
      'الرجاء إدخال رمز التحقق المكون من {pincodeLength} أرقام المرسل إلى رقم هاتفك المتحرك {mobileNumber}',
    ENTER_PINCODE_MSG:
      'الرجاء إدخال رمز التحقق المرسل إلى رقم هاتفك المحمول {mobileNumber}',
    ChangeNumber: 'تغيير الرقم',
    didnotReceiveCodeLbl: 'لم تحصل على رمز التحقق؟',
    ResendPinCodeIn: 'أعد الإرسال خلال ',
    static_error_title: 'حدث خطأ',
    static_success_title: 'تهانينا',
    static_pending_title: 'طلبك قيد التنفيذ',
    static_error_body:
      'يرجى المحاولة مرة أخرى باستخدام نفس الرابط الذي تلقيته.',
    static_success_body:
      'لقد تمت إعادة  اشتراكك بنجاح. الرجاء استخدام نفس البيانات التي تلقيتها مسبقًا للوصول إلى الخدمة',
    static_pending_body:
      'يرجى التحقق بعد فترة. يمكنك استخدام نفس البيانات التي تلقيتها مسبقًا للوصول إلى الخدمة.',
  },
};
